/*
 * ACS bulk ladder
 * ---------------------------------------------------------------------------
 * The ladder is rendered in full by sections/acs-bulk-ladder.liquid: one
 * <tbody> per option combination, every price already formatted by Liquid's
 * money filter, with only the selected combination visible. This file's ONLY
 * job is to swap which <tbody> that is when the shopper picks a different
 * size, and to move the "current tier" highlight.
 *
 * Nothing here computes or formats a price, so the section is completely
 * correct with JavaScript disabled — it simply stops following the picker.
 *
 * It listens on Craft's own pub/sub (assets/pubsub.js): the event name is
 * PUB_SUB_EVENTS.variantChange ('variant-change') and product-info.js
 * publishes it as { data: { sectionId, html, variant } }, with `variant`
 * guaranteed non-null because the unavailable path returns before publishing.
 *
 * Wrapped in an IIFE and guarded on customElements.get so a second copy of
 * the script (two instances of the section on one page) cannot redefine the
 * element and throw.
 * ------------------------------------------------------------------------- */

(function () {
  if (typeof window.customElements === 'undefined' || window.customElements.get('acs-bulk-ladder')) return;

  var VARIANT_CHANGE =
    (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) || 'variant-change';

  class AcsBulkLadder extends HTMLElement {
    connectedCallback() {
      // pubsub.js is loaded in the layout, but never assume: without it the
      // server-rendered ladder is simply left as it is.
      if (typeof subscribe !== 'function' || this.unsubscribe) return;

      this.unsubscribe = subscribe(VARIANT_CHANGE, (event) => {
        var variant = event && event.data && event.data.variant;
        if (!variant || variant.id === undefined || variant.id === null) return;
        this.showVariant(String(variant.id));
      });
    }

    disconnectedCallback() {
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
      }
    }

    /** Reveal the tier list the given variant belongs to and highlight its row. */
    showVariant(variantId) {
      // Ids are always digits; refuse anything else rather than build a
      // selector out of it.
      if (!/^\d+$/.test(variantId)) return;

      var row = this.querySelector('tr[data-variant-id="' + variantId + '"]');
      // No row means this combination has no ladder worth showing (a size with
      // a single tier, say). Leaving the last good group visible beats blanking
      // the card.
      if (!row) return;

      var group = row.closest('[data-ladder-group]');
      if (!group) return;

      this.querySelectorAll('[data-ladder-group]').forEach(function (candidate) {
        candidate.hidden = candidate !== group;
      });

      this.querySelectorAll('tr[data-variant-id]').forEach(function (candidate) {
        var isCurrent = candidate === row;
        candidate.classList.toggle('acs-bulk-ladder__row--current', isCurrent);
        if (isCurrent) {
          candidate.setAttribute('aria-current', 'true');
        } else {
          candidate.removeAttribute('aria-current');
        }
        var mark = candidate.querySelector('[data-ladder-mark]');
        if (mark) mark.hidden = !isCurrent;
      });
    }
  }

  window.customElements.define('acs-bulk-ladder', AcsBulkLadder);
})();
